<mat-sidenav-container class="template-drawer-container" fullscreen [style.position]="sidenav.opened ? 'fixed' : 'relative'">
  <mat-sidenav
    #sidenav
    mode="over"
    position="end"
    class="sidenav container_nav"
    [ngClass]="isImpersonating ? 'impersonating-margin' : ''"
    [fixedInViewport]="true"
    [fixedTopGap]="0"
    (openedChange)="handleNav($event)"
  >
    <form *ngIf="sidenav.opened">
      <div class="web-close-icon">
        <button (click)="closeSideNav()" class="web-close-btn">
          <img src="/assets/images/close-black.svg" />
        </button>
      </div>

      <div class="mobile-close-container">
        <div class="top-row">
          <div class="action-icon">
            <button mat-icon-button (click)="handleMobileMenuDrawer()">
              <mat-icon>menu</mat-icon>
            </button>
          </div>
          <div class="middle-container">
            <h3 class="mobile-main-title">
              {{ is_filter_name ? is_filter_name + ' Templates' : 'Template' }}
            </h3>
            <div class="mobile-search-container" (click)="handleMobileSearch()">
              <img src="assets/images/mobile-sidenav-search.svg" />
            </div>
          </div>
          <div class="action-icon">
            <button mat-icon-button (click)="closeSideNav()">
              <mat-icon>clear</mat-icon>
            </button>
          </div>
        </div>
        <div class="bottom-row" *ngIf="openMobileSearch">
          <div class="mobile-search-box-container">
            <mat-form-field appearance="fill" class="view-template-form-design" style="width: 100%; height: 36px !important; margin-top: 10px">
              <mat-icon matPrefix style="text-align: center; transform: translateY(5px)">search</mat-icon>
              <input
                matInput
                placeholder="Search Templates"
                [(ngModel)]="searchedStr"
                name="searchedStr"
                (input)="searchTemplates($event.target.value)"
                class="view-template-search-input"
                autocomplete="off"
              />
              <!-- (input)="getSearchedForms($event.target.value)" -->
              <button
                mat-button
                *ngIf="searchedStr"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="clearSearchAction()"
                class="search-close-icon"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>

        <!-- mobile handler for left nav -->
        <!-- <div class="mobile-close-icon" *ngIf="!isSearchactive">
          <div class="close add-close-button-mobile" (click)="closeSideNav()">
            <span class="material-icons close-icon-mobile">clear</span>
          </div>
        </div>

        mobile close for side nav 
        <div class="mobile-close-icon" *ngIf="!isSearchactive">
          <div class="close add-close-button-mobile" (click)="closeSideNav()">
            <span class="material-icons close-icon-mobile">clear</span>
          </div>
        </div> -->
      </div>

      <div class="viewContainer">
        <!-- template sidenav -->
        <div class="template-sidenav" *ngIf="openMenuDrawer" [ngClass]="openMobileMenuDrawer ? 'display-block' : ''">
          <div class="sidenav-web">
            <h3 class="template-sidenav-main-title">
              {{ is_filter_name ? is_filter_name + ' Templates' : 'Template' }}
            </h3>
            <div class="search-box-container">
              <mat-form-field appearance="fill" class="view-template-form-design" style="width: 100%; height: 36px !important; margin-top: 10px">
                <mat-icon matPrefix style="text-align: center; transform: translateY(5px)">search</mat-icon>
                <input
                  matInput
                  placeholder="Search Templates"
                  [(ngModel)]="searchedStr"
                  name="searchedStr"
                  (input)="searchTemplates($event.target.value)"
                  class="view-template-search-input"
                  autocomplete="off"
                />
                <!-- (input)="getSearchedForms($event.target.value)" -->
                <button
                  mat-button
                  *ngIf="searchedStr"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="clearSearchAction()"
                  class="search-close-icon"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div class="width-100per" *ngIf="vaultStateObject$ && defaultFolders && openMenuDrawer" style="margin-top: 0px">
              <mat-nav-list class="sidenav-item" *ngIf="ShowLocatioOrIsassets" [disableRipple]="true">
                <mat-list-item class="menu-title menu-button-item" [ngClass]="{ 'active-tax': !searchedStr }">
                  <span class="material-icons menu-icon play-arrow"> arrow_drop_down </span>

                  <p class="view-container-list-text">Location</p>
                </mat-list-item>
              </mat-nav-list>
              <mat-nav-list class="sidenav-item" [disableRipple]="true" *ngIf="is_filter != -1">
                <div *ngFor="let item of templateCategoriesSection; let i = index">
                  <mat-list-item
                    class="menu-title menu-button-item menu-btn"
                    [ngClass]="{ 'active-tax': item.is_list_loaded }"
                    (click)="togglemenu(item.section_name, i)"
                  >
                    <!-- (click)="togglemenu(listName, i)" -->
                    <!-- [ngClass]="{ 'active-tax': item.is_list_loaded && !item.is_list_open }" -->
                    <!-- <span
                      class="material-icons menu-icon"
                      *ngIf="item.is_list_loaded && item.is_list_open; else playArrow"
                      (click)="toggle(listName, i); $event.stopPropagation()"
                    >
                      arrow_drop_down
                    </span>

                    <ng-template #playArrow>
                      <span class="material-icons menu-icon play-arrow" (click)="togglemenu(listName, i); $event.stopPropagation()">
                        arrow_drop_down</span
                      >
                    </ng-template> -->
                    <p class="view-container-list-text" [matTooltip]="item.section_name">
                      <!-- <img src="assets/images/{{ item.image }}" style="height: 25px; width: 25px; padding-right: 10px" /> -->
                      {{ item.section_name }}
                    </p>
                  </mat-list-item>
                  <!-- <div *ngIf="item.is_list_loaded && item.is_list_open">
                    <mat-list-item
                      [ngClass]="{ 'active-tax': list.is_active }"
                      class="menu-title menu-button-item"
                      *ngFor="let list of item.sublist; let j = index"
                      (click)="closetMatDrawer(); setSubListActive(j, i)"
                    >
                      <span style="margin-left: 40px">
                        {{ list.name }}
                      </span>
                    </mat-list-item>
                  </div> -->
                </div>
              </mat-nav-list>
              <mat-nav-list class="sidenav-item" [disableRipple]="true" *ngIf="is_filter == -1">
                <!-- *ngFor="let item of templateCategories; let i = index"-->
                <div>
                  <mat-list-item class="menu-title menu-button-item menu-btn" [ngClass]="{ 'active-tax': is_filter == -1 }">
                    <p class="view-container-list-text">{{ is_filter_name }} Templates</p>
                  </mat-list-item>
                </div>
                <div></div>
              </mat-nav-list>

              <!-- <div class="view-container-list-wrapper" *ngIf="!data?.hideAllTemplates && isProfessional$ | async">
            <p class="view-container-list-text" (click)="getFolderList(getAllForms, 'professional', 106)" [class.active2]="isClicked === 106">
              <img src="assets/images/professional-icon.svg" style="height: 20px; width: 20px" />
              <span style="padding-left: 6px">Professional</span>
            </p>
          </div> -->

              <ng-container *ngFor="let item of defaultFolders; let i = index">
                <div
                  class="view-container-list-wrapper"
                  *ngIf="defaultFolders.length == 1"
                  (click)="closetMatDrawer(); getFolderList(item, '', item.id)"
                  [class.active]="isClicked === item.id"
                  [class.active2]="hideAllTemplates"
                >
                  <p class="view-container-list-text">
                    <img src="assets/images/{{ item.image }}" style="height: 25px; width: 25px; padding-right: 10px" />{{ item.name }}
                  </p>
                </div>
              </ng-container>
              <!-- <div class="bedge-container" style="margin-top: 12px">
                <div>
                  <img class="bedge-image" src="assets/images/create-bedge.svg" />
                </div>
                <div>
                  <p class="bedge-text"><b>SECURE 256 BIT</b> Data Encryption</p>
                </div>
              </div> -->
            </div>
          </div>
        </div>

        <span class="divider"></span>

        <!-- template body -->
        <div class="template-body" style="padding-bottom: 12px !important">
          <!-- <div class="mobile-search-box-container" *ngIf="!isSearchactive">
            <div class="sidenav-folder-main-img" (click)="openMenuDrawer = !openMenuDrawer">
              <button class="manu-button">
                <mat-icon style="margin-right: 4px">menu</mat-icon>
                {{ is_filter_name ? is_filter_name + ' Templates' : 'Template' }}
              </button>
            </div>
            <div (click)="toggleSearch(); openMenuDrawer = false" class="mobile-search-container">
              <img src="assets/images/mobile-sidenav-search.svg" />
            </div>
          </div>

          <span style="padding-left: 10px" *ngIf="!searchClicked && !isSearchactive" class="subcate-text">{{ selectedCategoryName }}</span>

          <h2
            class="recently-used-text-search"
            style="padding-top: 32px; padding-left: 44px"
            *ngIf="searchClicked && SearchedFormArray && screenWidth > 480 && ShowLocatioOrIsassets && !isProfessionalTemplate"
          >
            {{ SearchedFormArray.length }} Results Related To "{{ searchedStr }}"
          </h2> -->
          <div class="heading-text" *ngIf="currentFolderName?.name != 'Assets' || searchClicked">
            <!-- <h2 class="heading-text-main" *ngIf="!searchClicked && !isSearchactive && !isProfessionalTemplate">
              <div *ngIf="screenWidth > 480">
                <img
                  *ngIf="currentFolderName; else allTemplateImage"
                  src="assets/images/{{ currentFolderName.image }}"
                  style="height: 16px; width: 16px; margin-bottom: 4px"
                />
                <ng-template #allTemplateImage>
                  <img src="assets/images/all-template-icon.svg" style="height: 16px; width: 16px; margin-bottom: 4px" />
                </ng-template>
              </div>
              <div *ngIf="currentFolderName; else allTemplatesText">
                <span style="padding-left: 10px">{{ currentFolderName.name }}</span>

                <div class="isCheckBox-add-container" *ngIf="isCheckBox">
                  <button
                    mat-raised-button
                    type="button"
                    class="checkbox-add-btn"
                    [class.disable-button-continue]="checklistTotalList?.length == 0 || loading"
                    (click)="null"
                  >
                    Finish
                  </button>
                </div>
              </div>

              <ng-template #allTemplatesText>
                <span style="padding-left: 10px">All Templates</span>

                <div class="isCheckBox-add-container-2" *ngIf="isCheckBox">
                  <button
                    mat-raised-button
                    type="button"
                    class="checkbox-add-btn-2"
                    [class.disable-button-continue]="checklistTotalList?.length == 0 || loading"
                    (click)="null"
                  >
                    Finish
                  </button>
                </div>
              </ng-template>
            </h2> -->

            <h2 class="heading-text-main" *ngIf="(isProfessional$ | async) && isProfessionalTemplate">
              <img src="assets/images/professional-icon.svg" style="height: 20px; width: 20px; margin-bottom: 4px" />
              <span style="padding-left: 10px">Professional</span>

              <div class="isCheckBox-add-container" *ngIf="isCheckBox" style="width: 62%; margin-top: 0px">
                <button
                  mat-raised-button
                  type="button"
                  class="checkbox-add-btn"
                  [class.disable-button-continue]="checklistTotalList?.length == 0 || loading"
                  (click)="(null)"
                >
                  Finish
                </button>
              </div>
            </h2>

            <h2
              class="recently-used-text-search"
              style="padding-top: 48px; padding-left: 14px; position: relative; top: -12px"
              *ngIf="searchClicked && SearchedFormArray && screenWidth > 480 && !isProfessionalTemplate"
            >
              {{ SearchedFormArray.length }} Results Related To "{{ searchedStr }}"
            </h2>

            <div
              class="isCheckBox-add-container"
              style="margin-top: -32px; margin-right: 70px"
              *ngIf="isCheckBox && searchClicked && SearchedFormArray && screenWidth > 480"
            >
              <button
                mat-raised-button
                type="button"
                class="checkbox-add-btn"
                [class.disable-button-continue]="checklistTotalList.length == 0 || loading"
                (click)="(null)"
              >
                Finish
              </button>
            </div>
            <div class="search-mobile" *ngIf="searchClicked || isSearchactive">
              <div class="search-mobile-container">
                <mat-form-field
                  appearance="fill"
                  class="view-template-form-design"
                  [ngClass]="!isCheckBox ? 'template-search-mobile-without-checklist' : 'template-search-mobile'"
                >
                  <mat-icon matPrefix style="text-align: center; transform: translateY(5px)">search</mat-icon>
                  <input
                    matInput
                    placeholder="Search"
                    [(ngModel)]="searchedStr"
                    name="searchedStr"
                    (input)="getSearchedForms($event.target.value)"
                    class="view-template-search-input"
                    autocomplete="off"
                  />
                  <button mat-button matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()" class="search-close-icon">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>

                <div
                  class="isCheckBox-add-container"
                  style="margin-top: -32px"
                  [class.disable-button-continue-2]="checklistTotalList.length == 0 || loading"
                  *ngIf="isCheckBox"
                >
                  <button mat-raised-button type="button" class="add-btn-for-search" (click)="(null)">Finish</button>
                </div>
              </div>
            </div>
          </div>
          <div class="inner-container">
            <!-- TEMPLATE FOR FOLDERS -->
            <!-- <div class="vault-view" *ngIf="!searchClicked" id="templateCenterFolderView"> -->
            <!-- checklist view START-->
            <!-- <div class="checklist-container" *ngIf="isCheckBox">
                <div class="checklist-container-main" *ngIf="checklistForm?.length >= 1">
                  <h2 class="checklist-container-text">
                    Added <span style="padding-left: 5px; color: black; font-weight: 700">({{ checklistTotalList?.length }})</span>
                  </h2>

                  <div class="checklist-container-toggle-icon" (click)="toggleChecklistItems()">
                    <i class="material-icons" *ngIf="isexpanded; else notExpanded">expand_more</i>
                    <ng-template #notExpanded>
                      <i class="material-icons">expand_less</i>
                    </ng-template>
                  </div>
                </div>

                <div class="wrapper-container-for-checklist" *ngIf="isexpanded">
                  <div class="checklist-main-wrapper" *ngFor="let form of checklistForm">
                    <div class="checklist-main-left">
                      <p class="checklist-main-left-text">{{ form.itemLength }}</p>
                    </div>

                    <div class="checklist-main-right">
                      <p class="checklist-main-right-text">
                        {{ form.type }}
                      </p>
                      <div class="checklist-main-right-btn" (click)="removeChecklist(form)">
                        <i class="material-icons remove-circle-btn">remove_circle</i>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
            <!-- checklist view END -->

            <!-- <div class="commonlyUsed" *ngIf="commenlyUsed?.length && !ShowLocatioOrIsassets">
              <h2 class="commenly-used-folders"><span style="color: #25508e">•</span> Commonly Used</h2>
              <div class="vault-view__folders">
                <div class="static-cards" *ngFor="let forms of commenlyUsed">
                  <div class="static-container" [ngStyle]="{ border: isCheckBox ? 'none' : '1px solid #F3F6FA' }">
                    <img src="{{ forms.image }}" class="static-container-image" />
                    <div class="img-overlay" [ngClass]="{ 'img-overlay-hovered': forms.id | templatedAdded: checklistForm }"></div>
                    <button type="button" class="static-container-btn" (click)="addToMyFolders(forms)" *ngIf="!isCheckBox && !singleChecklist">
                      Select
                    </button>

                    <button type="button" class="static-container-btn" (click)="updateChecklist(forms)" *ngIf="singleChecklist">Select</button>

                    <button
                      type="button"
                      class="static-container-btn-2"
                      (click)="createChecklistForm(forms)"
                      *ngIf="isCheckBox && !(forms.id | templatedAdded: checklistForm)"
                    >
                      <img src="assets/images/add_circle.svg" class="static-container-btn-add-icon" />
                    </button>
                    <button type="button" class="static-container-btn-3" *ngIf="isCheckBox && (forms.id | templatedAdded: checklistForm)">
                      <mat-icon (click)="removeChecklist(forms)">remove</mat-icon>
                      <span
                        style="font-family: 'Open Sans'; font-style: normal; font-weight: 700; font-size: 16px; line-height: 24px; color: #010b18"
                      >
                        {{ forms.id | templatedAdded: checklistForm }}
                      </span>
                      <mat-icon (click)="createChecklistForm(forms)">add</mat-icon>
                    </button>
                  </div>
                  <h3 class="static-card-text">{{ forms.type }}</h3>
                </div>
              </div>
            </div> -->

            <div class="vault-view" *ngIf="!searchClicked && !isAllTemplates">
              <!-- <h2 class="commenly-used-folders" style="margin-top: 10px">
                  {{ categoryType == 'estate' ? 'Asset' : ShowLocatioOrIsassets ? is_filter_name : currentFolderName.name }}
                  Templates ({{ filteredList?.length }})
                </h2> -->
              <div *ngFor="let section of subSectionName">
                <h2 class="commenly-used-folders" style="margin-top: 10px" *ngIf="showSubSection(section?.sub_section_name)">
                  {{ section?.sub_section_name }}
                </h2>
                <div class="mt-4 vault-view__folders">
                  <div *ngFor="let forms of allTemplateForm; let i = index">
                    <!-- *ngIf="forms.sub_section && forms.sub_section == section.sub_section_name" -->
                    <!-- this is the latest static cards working on app -->
                    <div
                      class="static-cards"
                      *ngIf="
                        forms?.section_subsection_rank?.includes(selectedCategoryName) &&
                        forms?.section_subsection_rank?.includes(section.sub_section_name)
                      "
                    >
                      <div class="static-container" [ngStyle]="{ border: isCheckBox ? 'none' : '1px solid #F3F6FA' }">
                        <img src="{{ forms.image }}" class="static-container-image" />
                        <div class="img-overlay" [ngClass]="{ 'img-overlay-hovered': forms.id | templatedAdded : checklistForm }"></div>

                        <button type="button" class="static-container-btn" (click)="addToMyFolders(forms)" *ngIf="!isCheckBox && !singleChecklist">
                          Select
                        </button>

                        <button type="button" class="static-container-btn" (click)="updateChecklist(forms)" *ngIf="singleChecklist">Select</button>

                        <button
                          type="button"
                          class="static-container-btn-2"
                          (click)="createChecklistForm(forms)"
                          *ngIf="isCheckBox && !(forms.id | templatedAdded : checklistForm)"
                        >
                          <img src="assets/images/add_circle.svg" class="static-container-btn-add-icon" />
                        </button>
                        <button type="button" class="static-container-btn-3" *ngIf="isCheckBox && (forms.id | templatedAdded : checklistForm)">
                          <mat-icon (click)="removeChecklist(forms)">remove</mat-icon>
                          <span
                            style="font-family: 'Open Sans'; font-style: normal; font-weight: 700; font-size: 16px; line-height: 24px; color: #010b18"
                          >
                            {{ forms.id | templatedAdded : checklistForm }}
                          </span>
                          <mat-icon (click)="createChecklistForm(forms)">add</mat-icon>
                        </button>
                      </div>
                      <h3 class="static-card-text">{{ forms.type }}</h3>
                      <span class="d-flex">
                        <span
                          class="static-card-type"
                          [style.margin-left]="i > 0 ? '8px' : ''"
                          *ngFor="let type of forms.type_template_Array; let i = index"
                        >
                          <h4 class="static-card-type-text">
                            {{ forms.type_template_Array.length == 1 ? (type | truncateStrPipe : 25) : (type | truncateStrPipe : 11) }}
                          </h4>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- TEMPLATE FOR ALL TEMPLATE -->
            <div class="vault-view-all-templates" *ngIf="isAllTemplates && !searchClicked && !isSearchactive && !isProfessionalTemplate">
              <!-- checklist view START-->
              <div class="checklist-container" *ngIf="isCheckBox">
                <div class="checklist-container-main" *ngIf="checklistForm?.length >= 1">
                  <h2 class="checklist-container-text">
                    Added <span style="padding-left: 5px; color: black; font-weight: 700">({{ checklistTotalList?.length }})</span>
                  </h2>

                  <div class="checklist-container-toggle-icon" (click)="toggleChecklistItems()">
                    <i class="material-icons" *ngIf="isexpanded; else notExpanded">expand_more</i>
                    <ng-template #notExpanded>
                      <i class="material-icons">expand_less</i>
                    </ng-template>
                  </div>
                </div>

                <div class="wrapper-container-for-checklist" *ngIf="isexpanded">
                  <div class="checklist-main-wrapper" *ngFor="let form of checklistForm">
                    <div class="checklist-main-left">
                      <p class="checklist-main-left-text">{{ form.itemLength }}</p>
                    </div>

                    <div class="checklist-main-right">
                      <p class="checklist-main-right-text">
                        {{ form.type }}
                      </p>

                      <div class="checklist-main-right-btn" (click)="removeChecklist(form)">
                        <i class="material-icons remove-circle-btn">remove_circle</i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- checklist view END -->

              <!--  commenly used -->
              <!-- <div class="commonlyUsed" *ngIf="commenlyUsed?.length">
              <h2 class="recently-used-text" style="padding-top: 5px"><span style="color: #25508e">•</span> Commonly Used</h2>
              <div class="vault-view__folders-template">
                <div class="static-cards" *ngFor="let forms of commenlyUsed">
                  <div class="static-container" [ngStyle]="{ border: isCheckBox ? 'none' : '1px solid #F3F6FA' }">
                    <img src="{{ forms.image }}" class="static-container-image" />
                    <div class="img-overlay" [ngClass]="{ 'img-overlay-hovered': forms.id | templatedAdded: checklistForm }"></div>

                    <button type="button" class="static-container-btn" (click)="addToMyFolders(forms)" *ngIf="!isCheckBox && !singleChecklist">
                      Select
                    </button>

                    <button type="button" class="static-container-btn" (click)="updateChecklist(forms)" *ngIf="singleChecklist">Select</button>
                    <button type="button" class="static-container-btn-3" *ngIf="isCheckBox && (forms.id | templatedAdded: checklistForm)">
                      <mat-icon (click)="removeChecklist(forms)">remove</mat-icon>
                      <span
                        style="font-family: 'Open Sans'; font-style: normal; font-weight: 700; font-size: 16px; line-height: 24px; color: #010b18"
                      >
                        {{ forms.id | templatedAdded: checklistForm }}
                      </span>
                      <mat-icon (click)="createChecklistForm(forms)">add</mat-icon>
                    </button>

                    <button
                      type="button"
                      class="static-container-btn-2"
                      (click)="createChecklistForm(forms)"
                      *ngIf="isCheckBox && !(forms.id | templatedAdded: checklistForm)"
                    >
                      <img src="assets/images/add_circle.svg" class="static-container-btn-add-icon" />
                    </button>
                  </div>
                  <h3 class="static-card-text">{{ forms.type }}</h3>
                </div>
              </div>
            </div> -->

              <div class="recentlyUsed" *ngIf="allTemplateForm && allTemplateForm.length !== 0">
                <!-- <span style="color: #25508e">•</span>  -->
                <!-- <h2 class="mt-3 recently-used-text">All Template {{ allTemplateForm?.length }}</h2> -->
                <div class="flex justify-between items-center">
                  <h2 class="mt-3 recently-used-text" style="font-weight: 700 !important; color: black; font-size: 16px" *ngIf="!hasSubjectData">
                    {{ is_filter_name == 'All' ? 'A - Z' : 'All Location Templates' }} ({{ allTemplateForm?.length }})
                  </h2>
                  <h2 class="mt-3 recently-used-text" style="font-weight: 700 !important; color: black; font-size: 16px" *ngIf="hasSubjectData">
                    {{ 'All' + ' ' + hasSubjectData?.tag + ' ' + 'Templates' }} ({{ allTemplateForm?.length }})
                  </h2>
                  <p class="app__showOnMobile">
                    <button mat-icon-button (click)="closeSideNav()">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </p>
                </div>

                <!-- mt-4 vault-view__folders-template -->

                <div
                  [class]="
                    allTemplateForm.length > 2
                      ? 'flex flex-wrap justify-center container mb-4 w-full py-1'
                      : 'flex flex-wrap justify-start container mb-4 w-full py-1'
                  "
                >
                  <div class="static-cards" *ngFor="let forms of allTemplateForm">
                    <div class="static-containe" [ngStyle]="{ border: isCheckBox ? 'none' : '1px solid #F3F6FA' }">
                      <img src="{{ forms.image }}" class="static-container-image" />
                      <div class="img-overlay" [ngClass]="{ 'img-overlay-hovered': forms.id | templatedAdded : checklistForm }"></div>

                      <button type="button" class="static-container-btn" (click)="addToMyFolders(forms)" *ngIf="!isCheckBox && !singleChecklist">
                        Select
                      </button>

                      <button type="button" class="static-container-btn" (click)="updateChecklist(forms)" *ngIf="singleChecklist">Select</button>

                      <button
                        type="button"
                        class="static-container-btn-2"
                        (click)="createChecklistForm(forms)"
                        *ngIf="isCheckBox && !(forms.id | templatedAdded : checklistForm)"
                      >
                        <img src="assets/images/add_circle.svg" class="static-container-btn-add-icon" />
                      </button>
                      <button type="button" class="static-container-btn-3" *ngIf="isCheckBox && (forms.id | templatedAdded : checklistForm)">
                        <mat-icon (click)="removeChecklist(forms)">remove</mat-icon>
                        <span
                          style="font-family: 'Open Sans'; font-style: normal; font-weight: 700; font-size: 16px; line-height: 24px; color: #010b18"
                        >
                          {{ forms.id | templatedAdded : checklistForm }}
                        </span>
                        <mat-icon (click)="createChecklistForm(forms)">add</mat-icon>
                      </button>
                    </div>
                    <h3 class="static-card-text">{{ forms.type }}</h3>
                    <span class="d-flex">
                      <span
                        class="static-card-type"
                        [style.margin-left]="i > 0 ? '8px' : ''"
                        *ngFor="let type of forms.type_template_Array; let i = index"
                      >
                        <h4 class="static-card-type-text">
                          {{ forms.type_template_Array.length == 1 ? type : (type | truncateStrPipe : 15) }}
                        </h4>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- TEMPLATE FOR SEARCH -->
            <div class="vault-view-all-templates" *ngIf="searchClicked">
              <!-- *ngIf="(searchClicked || isSearchactive) && !isProfessionalTemplate" -->
              <div *ngIf="screenWidth <= 480 && !searchClicked">
                <div class="search-mobile-zerostate">
                  <img src="assets/images/template-center-search-mobile.svg" class="search-mobile-zerostate-img" />
                  <p class="search-mobile-zerostate-text">Start searching to find templates</p>
                </div>
              </div>

              <h2 class="recently-used-text-search-mobile" *ngIf="searchClicked && SearchedFormArray && screenWidth <= 480">
                {{ SearchedFormArray.length }} Results Related To "{{ searchedStr }}"
              </h2>

              <!-- checklist view START-->
              <div class="checklist-container" *ngIf="isCheckBox">
                <div class="checklist-container-main" *ngIf="checklistForm?.length >= 1">
                  <h2 class="checklist-container-text">
                    Added <span style="padding-left: 5px; color: black; font-weight: 700">({{ checklistTotalList?.length }})</span>
                  </h2>

                  <div class="checklist-container-toggle-icon" (click)="toggleChecklistItems()">
                    <i class="material-icons" *ngIf="isexpanded; else notExpanded">expand_more</i>
                    <ng-template #notExpanded>
                      <i class="material-icons">expand_less</i>
                    </ng-template>
                  </div>
                </div>

                <div class="wrapper-container-for-checklist" *ngIf="isexpanded">
                  <div class="checklist-main-wrapper" *ngFor="let form of checklistForm">
                    <div class="checklist-main-left">
                      <p class="checklist-main-left-text">{{ form.itemLength }}</p>
                    </div>

                    <div class="checklist-main-right">
                      <p class="checklist-main-right-text">
                        {{ form.type }}
                      </p>

                      <div class="checklist-main-right-btn" (click)="removeChecklist(form)">
                        <i class="material-icons remove-circle-btn">remove_circle</i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- checklist view END -->

              <div class="search" *ngIf="SearchedFormArray && SearchedFormArray.length !== 0 && searchClicked">
                <div class="vault-view__folders-template">
                  <div class="static-cards" *ngFor="let forms of SearchedFormArray">
                    <div class="static-container" [ngStyle]="{ border: isCheckBox ? 'none' : '1px solid #F3F6FA' }">
                      <img src="{{ forms.image }}" class="static-container-image" />
                      <div class="img-overlay" [ngClass]="{ 'img-overlay-hovered': forms.id | templatedAdded : checklistForm }"></div>

                      <button type="button" class="static-container-btn" (click)="addToMyFolders(forms)" *ngIf="!isCheckBox && !singleChecklist">
                        Select
                      </button>

                      <button type="button" class="static-container-btn" (click)="updateChecklist(forms)" *ngIf="singleChecklist">Select</button>

                      <button
                        type="button"
                        class="static-container-btn-2"
                        (click)="createChecklistForm(forms)"
                        *ngIf="isCheckBox && !(forms.id | templatedAdded : checklistForm)"
                      >
                        <img src="assets/images/add_circle.svg" class="static-container-btn-add-icon" />
                      </button>
                      <button type="button" class="static-container-btn-3" *ngIf="isCheckBox && (forms.id | templatedAdded : checklistForm)">
                        <mat-icon (click)="removeChecklist(forms)">remove</mat-icon>
                        <span
                          style="font-family: 'Open Sans'; font-style: normal; font-weight: 700; font-size: 16px; line-height: 24px; color: #010b18"
                        >
                          {{ forms.id | templatedAdded : checklistForm }}
                        </span>
                        <mat-icon (click)="createChecklistForm(forms)">add</mat-icon>
                      </button>
                    </div>
                    <h3 class="static-card-text">{{ forms.type }}</h3>
                    <span class="d-flex">
                      <span
                        class="static-card-type"
                        [style.margin-left]="i > 0 ? '8px' : ''"
                        *ngFor="let type of forms.type_template_Array; let i = index"
                      >
                        <h4 class="static-card-type-text">
                          {{ forms.type_template_Array.length == 1 ? type : (type | truncateStrPipe : 15) }}
                        </h4>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- TEMPLATE FOR PROFESSIONAL -->
            <div
              class="vault-view-all-templates"
              *ngIf="!isAllTemplates && !searchClicked && !isSearchactive && isProfessionalTemplate && (isProfessional$ | async)"
            >
              <!-- checklist view START-->
              <div class="checklist-container" *ngIf="isCheckBox">
                <div class="checklist-container-main" *ngIf="checklistForm?.length >= 1">
                  <h2 class="checklist-container-text">
                    Added <span style="padding-left: 5px; color: black; font-weight: 700">({{ checklistTotalList?.length }})</span>
                  </h2>

                  <div class="checklist-container-toggle-icon" (click)="toggleChecklistItems()">
                    <i class="material-icons" *ngIf="isexpanded; else notExpanded">expand_more</i>
                    <ng-template #notExpanded>
                      <i class="material-icons">expand_less</i>
                    </ng-template>
                  </div>
                </div>

                <div class="wrapper-container-for-checklist" *ngIf="isexpanded">
                  <div class="checklist-main-wrapper" *ngFor="let form of checklistForm">
                    <div class="checklist-main-left">
                      <p class="checklist-main-left-text">{{ form.itemLength }}</p>
                    </div>

                    <div class="checklist-main-right">
                      <p class="checklist-main-right-text">
                        {{ form.type }}
                      </p>

                      <div class="checklist-main-right-btn" (click)="removeChecklist(form)">
                        <i class="material-icons remove-circle-btn">remove_circle</i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- checklist view END -->

              <div class="recentlyUsed" *ngIf="professionalForm && professionalForm.length !== 0">
                <!-- <h2 class="recently-used-text"><span style="color: #25508e">•</span> professional</h2> -->
                <div class="vault-view__folders-template">
                  <div class="static-cards" *ngFor="let forms of professionalForm">
                    <div class="static-container" [ngStyle]="{ border: isCheckBox ? 'none' : '1px solid #F3F6FA' }">
                      <img src="{{ forms.image }}" class="static-container-image" />
                      <div class="img-overlay" [ngClass]="{ 'img-overlay-hovered': forms.id | templatedAdded : checklistForm }"></div>

                      <button type="button" class="static-container-btn" (click)="addToMyFolders(forms)" *ngIf="!isCheckBox && !singleChecklist">
                        Select
                      </button>

                      <button type="button" class="static-container-btn" (click)="updateChecklist(forms)" *ngIf="singleChecklist">Select</button>

                      <button
                        type="button"
                        class="static-container-btn-2"
                        (click)="createChecklistForm(forms)"
                        *ngIf="isCheckBox && !(forms.id | templatedAdded : checklistForm)"
                      >
                        <img src="assets/images/add_circle.svg" class="static-container-btn-add-icon" />
                      </button>
                      <button type="button" class="static-container-btn-3" *ngIf="isCheckBox && (forms.id | templatedAdded : checklistForm)">
                        <mat-icon (click)="removeChecklist(forms)">remove</mat-icon>
                        <span
                          style="font-family: 'Open Sans'; font-style: normal; font-weight: 700; font-size: 16px; line-height: 24px; color: #010b18"
                        >
                          {{ forms.id | templatedAdded : checklistForm }}
                        </span>
                        <mat-icon (click)="createChecklistForm(forms)">add</mat-icon>
                      </button>
                    </div>
                    <h3 class="static-card-text">{{ forms.type }}</h3>
                    <span class="d-flex">
                      <span
                        class="static-card-type"
                        [style.margin-left]="i > 0 ? '8px' : ''"
                        *ngFor="let type of forms.type_template_Array; let i = index"
                      >
                        <h4 class="static-card-type-text">
                          {{ forms.type_template_Array.length == 1 ? type : (type | truncateStrPipe : 15) }}
                        </h4>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="footer-text">
              <p>Don’t see what you are looking for? <a style="font-weight: 700; cursor: pointer" (click)="contactAdminCenter()">Contact Us</a></p>
            </div>
          </div>
        </div>
      </div>
    </form>
  </mat-sidenav>
</mat-sidenav-container>
